/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
import $ from 'jquery';
import 'select2';

import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import 'select2/dist/css/select2.min.css';
import '~/sass/global.scss';
import '~/sass/icons/toyota-2016.scss';
import '~/sass/icons/toyota-2020.scss';
import '~/sass/icons/toyota-bz.scss';
import '~/sass/pages/map.scss';

import 'bootstrap';
import '@fancyapps/fancybox';
import '../components/input-select';

import { getUserGeo } from '@/utils/geo-info';
import { stationList } from '@/utils/maplist.json';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { autocomplete } from 'bootstrap-4-autocomplete';
import { init } from '@/components/map-extent';

const heightVH = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const { google } = window;
const windowWidth = $(window).width();
const LatLng = {
  Taiwan: {
    lat: windowWidth > 992 ? 24.0185554 : 24.1985554,
    lng: 121.0173702,
    bounds: {
      north: 25.50,
      south: 21.50,
      west: 118.15,
      east: 123.10,
    },
  },
};

$(document).ready(() => {
  let map = null;
  let infoWindow = null;
  const markers = [];
  let markerCluster = null;
  /*
  $('#getGeoLocation').on('click', async () => {
    const geoLocation = await getUserGeo();

    console.log(geoLocation);
  });

  // Sets the map on all markers in the array.
  function setMapOnAll(i) {
    markers[i].setMap(map);
    markerCluster.addMarker(markers[i]);
  }

  // Removes the markers from the map, but keeps them in the array.
  function hideMarkers(i) {
    markers[i].setMap(null);
    markerCluster.removeMarker(markers[i]);
  }
  */

  function ZoomControl1(div, mapOne) {
    // Creating divs & styles for custom zoom control
    const controlDiv = div;
    controlDiv.style.padding = '10px';

    // Set CSS for the control wrapper
    const controlWrapper = document.createElement('div');
    controlWrapper.classList = 'zoom-button-custom';
    controlDiv.appendChild(controlWrapper);

    // Set CSS for the zoomIn
    const zoomInButton = document.createElement('i');
    zoomInButton.classList = 'icon-bz icon-plus';
    controlWrapper.appendChild(zoomInButton);

    // Set CSS for the zoomOut
    const zoomOutButton = document.createElement('i');
    zoomOutButton.classList = 'icon-bz icon-minus';
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    google.maps.event.addDomListener(zoomInButton, 'click', () => {
      map.setZoom(mapOne.getZoom() + 1);
    });

    // Setup the click event listener - zoomOut
    google.maps.event.addDomListener(zoomOutButton, 'click', () => {
      map.setZoom(mapOne.getZoom() - 1);
    });
  }

  function initMap() {
    // map
    map = new google.maps.Map(document.getElementById('map-main'), {
      mapId: '7b48a2227f3801e0',
      zoom: 8,
      center: LatLng.Taiwan,
      disableDefaultUI: true,
      zoomControl: windowWidth > 992,
      minZoom: 7,
      maxZoom: 18,
      restriction: {
        latLngBounds: LatLng.Taiwan.bounds,
        // strictBounds: false,
      },
    });
    init(map);

    // Create the DIV to hold the control and call the ZoomControl() constructor
    // passing in this DIV.
    const zoomControlDiv = document.createElement('div');
    const zoomControl = new ZoomControl1(zoomControlDiv, map);

    zoomControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(zoomControlDiv);
    /*
    // infoWindow
    infoWindow = new google.maps.InfoWindow({
      minWidth: 320,
      pixelOffset: new google.maps.Size(0, -5),
    });

    // marker
    stationList.forEach((i) => {
      const iconObj = {
        // size: new google.maps.Size(32, 36),
        scaledSize: new google.maps.Size(32, 36),
        anchor: new google.maps.Point(18, 34),
      };
      const iconObjActive = {
        anchor: new google.maps.Point(22, 48),
      };
      if (i.type === 'DC') {
        // iconObj.url = '/public/images/icons/pin-DC.svg';
        iconObj.url = '/Bz-dev2/public/images/icons/pin-DC.svg';
        // iconObjActive.url = '/public/images/icons/pin-DC-active.svg';
        iconObjActive.url = '/Bz-dev2/public/images/icons/pin-DC-active.svg';
      } else if (i.type === 'AC') {
        // iconObj.url = '/public/images/icons/pin-AC.svg';
        iconObj.url = '/Bz-dev2/public/images/icons/pin-AC.svg';
        // iconObjActive.url = '/public/images/icons/pin-AC-active.svg';
        iconObjActive.url = '/Bz-dev2/public/images/icons/pin-AC-active.svg';
      } else {
        // iconObj.url = '/public/images/icons/pin-TOYOTA.svg';
        iconObj.url = '/Bz-dev2/public/images/icons/pin-TOYOTA.svg';
        // iconObjActive.url = '/public/images/icons/pin-TOYOTA-active.svg';
        iconObjActive.url = '/Bz-dev2/public/images/icons/pin-TOYOTA-active.svg';
      }

      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(i.latLng.lat, i.latLng.lng),
        icon: iconObj,
        myDefaultIcon: iconObj,
        map,
      });
      markers.push(marker);

      const markerInfo = `
      <article class="map-info-window">
        <div class="font-light mb-2">
        ${i.stationType}
        </div>
        <h5 class="font-bold font-s-1">
        ${i.name}
        </h5>
        <div class="font-s-2 mb-2">
        ${i.address}
        </div>
        <div class="border-bottom mb-4 pb-4 font-s-3">
          <i class="icon-bz icon-clock"></i> ${i.openHours}
        </div>
        <div class="font-bold font-s-2">
          <i class="icon-bz icon-chargeformat"></i> 充電資訊
        </div>
        <div class="font-light mb-4">
          <div class="font-s-2">${i.info.type}</div>
          <div class="font-s-3">${i.info.note}</div>
        </div>
        <div class="font-bold font-s-2">
          <i class="icon-bz icon-phone"></i> 聯絡電話
        </div>
        <div class="font-light mb-2 font-s-2">
          ${i.tel}
        </div>
        <div class="d-flex justify-content-end text-bluegreen-1">
          <a href="${i.routeUrl}" class="font-s-2">
            <i class="icon-bz icon-GPS"></i> 路徑規劃
          </a>
        </div>
      </article>`;

      // eslint-disable-next-line no-shadow
      google.maps.event.addListener(marker, 'click', (function mark(marker, i) {
        return function window() {
          // marker 回歸預設狀態
          markers.forEach((e) => {
            e.setIcon(e.myDefaultIcon);
          });
          marker.setIcon(iconObjActive);
          infoWindow.setContent(markerInfo);
          infoWindow.close();
          infoWindow.open(map, marker);
          map.setZoom(15);
          map.panTo(marker.getPosition(0, 110));
        };
      }(marker, i)));
      infoWindow.addListener('closeclick', () => {
        markers.forEach((e) => {
          e.setIcon(e.myDefaultIcon);
        });
      });
    });
    const defaultrenderer = {
      render: function renderer({ count, position }, stats) {
        // create svg url with fill color
        const svg = window.btoa(`
        <svg width="42" height="47" viewBox="0 0 42 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1267_1597)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.8708 38.5672C24.0193 38.3099 24.2755 38.1335 24.5668 38.0754C32.6785 36.4567 38.7912 29.2967 38.7912 20.7091C38.7912 10.9286 30.8626 3 21.0821 3C11.3017 3 3.37305 10.9286 3.37305 20.7091C3.37305 28.9799 9.04299 35.9265 16.708 37.8738C16.9778 37.9424 17.212 38.1132 17.3512 38.3543L19.8064 42.6068C20.1913 43.2735 21.1536 43.2735 21.5385 42.6068L23.8708 38.5672Z" fill="#006D7A"/>
        </g>
        <defs>
        <filter id="filter0_d_1267_1597" x="0.373047" y="0" width="41.418" height="46.1064" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="1.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1267_1597"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1267_1597" result="shape"/>
        </filter>
        </defs>
        </svg>`);
        // create marker using svg icon
        return new google.maps.Marker({
          position,
          icon: {
            url: `data:image/svg+xml;base64,${svg}`,
            scaledSize: new google.maps.Size(45, 47),
            anchor: new google.maps.Point(23, 47),
          },
          label: {
            text: String(count),
            color: 'rgba(255,255,255,0.9)',
            fontSize: '16px',
            className: 'marker-label',
          },
          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        });
      },
    };
    markerCluster = new MarkerClusterer({
      markers,
      map,
      onClusterClick: (e, c, m) => {
        // c.bounds
        const bounds = new google.maps.LatLngBounds();
        for (let i = 0; i < c.markers.length; i += 1) {
          const position = new google.maps.LatLng(c.markers[i].position.lat(), c.markers[i].position.lng());
          bounds.extend(position);
        }
        // m.setZoom(e.getMaxZoom() + 1);
        // m.panTo(bounds.getCenter());
        m.fitBounds(bounds);
        m.panTo(bounds.getCenter());
      },
      algorithm: new SuperClusterAlgorithm({
        // radius: 40, 畫面半徑距離
        maxZoom: 14,
      }),
      renderer: defaultrenderer,
    });
    */
  }

  initMap();
  heightVH();
  /*

  $('.icon-search').on('click', () => {
    console.log('icon search');
    hideMarkers(0);
  });
  $('.icon-filter').on('click', () => {
    console.log('icon filter');
    setMapOnAll(0);
  });
  function onSelectItem(item, element) {
    console.log(item);
  }
  $('#keywords-input-pc').autocomplete({
    source: stationList,
    label: 'address',
    highlightClass: 'text-danger',
    treshold: 1,
    maximumItems: 5,
    value: 'name',
    onSelectItem,
  });
  $('#keywords-input-mobile').autocomplete({
    source: stationList,
    label: 'address',
    highlightClass: 'text-danger',
    treshold: 1,
    maximumItems: 5,
    value: 'name',
    onSelectItem,
  });
  */
});
